import { BaseError } from '@nsftx/seven-client-retail-utils'

export type SlipPayoutValidationErrorType = 'SS_SLIP_PAYOUT_VALIDATION_WORKING_TIME_ERROR'

export default class SlipPayoutValidationError extends BaseError<SlipPayoutValidationErrorType> {
  constructor(
    public message: string,
    public code: SlipPayoutValidationErrorType,
  ) {
    super(message, code)
    Object.setPrototypeOf(this, SlipPayoutValidationError.prototype)
    this.name = this.constructor.name
  }
}
